import { Chip } from "@mui/material";

// Node status is two-state: a shield node is either heartbeating (running) or it
// is not (disconnected). The extra literals are values written by older builds, or
// by the database/activity-db rows on the services list, and are mapped here so a
// mixed-version cluster never renders a raw string.
export default function StatusChip({ status }: { status: string }) {
    const normalized = (status || "").toLowerCase();
    let color: "success" | "error" | "default" = "default";
    let label = "Unknown";

    if (normalized === "running" || normalized === "connected") {
        color = "success";
        label = "Running";
    } else if (["disconnected", "halted", "failed", "unrecoverable_error"].includes(normalized)) {
        color = "error";
        label = "Disconnected";
    }

    return <Chip variant="outlined" size="small" color={color} label={label} sx={{ minWidth: "92px" }} />;
}
